// pages/auth/Login.js
import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../services/api'
import { UserContext } from '../../context/UserContext'

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')
  const { setUserAndStore } = useContext(UserContext)
  const navigate = useNavigate()

  const handleLogin = async () => {
    try {
      const res = await api.post('/auth/login', { email, password })
      const token = res.data.token
      localStorage.setItem('token', token)
      const me = await api.get('/user/me')
      const info = {
        name: me.data.name,
        surname: me.data.surname,
        email: me.data.email,
        domain: me.data.domain,
        userId: me.data.userId,
        companyId: me.data.companyId,
        companyName: me.data.companyName,
        role: me.data.role
      }
      setUserAndStore(info, token)
      setMessage('Login successful')
      navigate('/app/dashboard')
    } catch (err) {
      setMessage(err.response?.data?.error || 'Error')
    }
  }

  return (
    <div className="page-container">
      <h2>Login</h2>
      <div className="form-group">
        <label>Email</label>
        <input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} />
      </div>
      <div className="form-group">
        <label>Password</label>
        <input type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} />
      </div>
      <button className="btn" onClick={handleLogin}>Login</button>
      {message && <p className="mt-1">{message}</p>}
    </div>
  )
}

export default Login